import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { RailsItemModel } from '~/typings/services/rails/item';
import { fetchListFlowModels } from '~/api/listFlow';
import { minutes30inMS } from '../../constants/times';
import { UseQueryResult } from '@tanstack/react-query';

export function useListFlowModels(
  params: {
    categoryId?: number | string;
    brandId?: number | string;
  },
  options?: UseQueryOptions<RailsItemModel[]>,
): UseQueryResult<RailsItemModel[]> {
  return useQuery<RailsItemModel[]>(
    ['list-flow-models', params],
    () => fetchListFlowModels(params.categoryId!, params.brandId),
    {
      enabled: !!params.categoryId,
      staleTime: minutes30inMS,
      ...options,
    },
  );
}
